import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu, { BaseMenuItem, type MenuProps } from '@/components/Menu';
import { AddFileIcon, ScreenshotIcon } from '@/icons';
import FileInput from '@/components/inputs/FileInput';
import { classes } from './utils';

export type AttachmentMenuProps = {
  open: boolean;
  anchorTo: HTMLElement | null;
  anchorOrigin?: MenuProps['anchorOrigin'];
  transformOrigin?: MenuProps['transformOrigin'];
  onStartScreenshot?: () => void;
  onAddFiles: (files: File[]) => void;
  onClose: () => void;
};

export default function AttachmentMenu({
  open,
  anchorTo,
  anchorOrigin,
  transformOrigin,
  onStartScreenshot,
  onAddFiles,
  onClose,
}: AttachmentMenuProps) {
  return (
    <Menu
      anchorTo={anchorTo}
      open={open}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}>
      <FileInput
        multiple
        className={classes.input}
        id="new-files"
        accept="image/*"
        onSelect={onAddFiles}
      />
      <BaseMenuItem className={classes.menuItem}>
        <label className={classes.inputLabel} htmlFor="new-files">
          <ListItemIcon>
            <AddFileIcon />
          </ListItemIcon>
          <ListItemText>Upload File(s)</ListItemText>
        </label>
      </BaseMenuItem>
      {onStartScreenshot && (
        <BaseMenuItem className={classes.menuItem} onClick={onStartScreenshot}>
          <ListItemIcon>
            <ScreenshotIcon />
          </ListItemIcon>
          <ListItemText>Take screenshot</ListItemText>
        </BaseMenuItem>
      )}
    </Menu>
  );
}
